/* SCC: Find your deck. Chips filter the grid, "Show all" reveals the rest, Add to cart goes through the theme's cart
   drawer (or cart notification) exactly like the product page does, and falls back to a normal form post. */
(function () {
  if (window.sccFindLoaded) return;
  window.sccFindLoaded = true;

  function sccAddToCart(form, btn) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    btn.classList.add('is-busy');
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (res.status) { form.submit(); return; }
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'scc-find', productVariantId: fd.get('id'), cartData: res }); } catch (e) {}
        }
        if (cart && cart.renderContents) {
          cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        var txt = btn.querySelector('.scc-fd__addtxt');
        if (txt) {
          var was = txt.textContent;
          btn.classList.add('is-done');
          txt.textContent = 'Added';
          setTimeout(function () { btn.classList.remove('is-done'); txt.textContent = was; }, 1800);
        }
      })
      .catch(function () { btn.classList.remove('is-busy'); form.submit(); });
  }
  window.sccAddToCart = sccAddToCart;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.scc-fd__form[data-scc-add]')) return;
    e.preventDefault();
    sccAddToCart(form, form.querySelector('[type="submit"]'));
  });

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('.scc-fd__chips [data-chip]'));
    var more = root.querySelector('[data-more]');
    var empty = root.querySelector('[data-empty]');
    var initial = parseInt(root.dataset.initial, 10) || 12;
    if (window.matchMedia('(max-width: 749px)').matches) initial = Math.max(4, Math.round((initial * 2) / 3 / 2) * 2);
    var current = 'all';
    var expanded = false;

    function apply(animate) {
      var visible = 0, matching = 0;
      items.forEach(function (li) {
        var isPack = li.hasAttribute('data-pack');
        var match;
        if (current === 'all') match = !isPack;
        else if (current === 'packs') match = isPack;
        else match = (li.dataset.groups || '').indexOf('|' + current + '|') > -1;
        if (match) matching++;
        var show = match && (expanded || current !== 'all' || matching <= initial);
        li.hidden = !show;
        li.classList.remove('is-pop');
        if (show) {
          if (animate) { li.style.setProperty('--k', visible); void li.offsetWidth; li.classList.add('is-pop'); }
          visible++;
        }
      });
      if (more) more.hidden = !(current === 'all' && !expanded && matching > initial);
      if (empty) empty.hidden = visible > 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        current = chip.dataset.chip;
        chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply(true);
      });
    });
    if (empty) {
      var back = empty.querySelector('[data-chip]');
      if (back) back.addEventListener('click', function () { if (chips[0]) chips[0].click(); });
    }
    if (more) more.addEventListener('click', function () { expanded = true; apply(true); more.blur(); });
    apply(false);
  }

  function boot() { document.querySelectorAll('[data-scc-find]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
